import { useEffect, useMemo, useState } from "react";

export function useDisplayMode() {
  const [displayMode, setDisplayMode] = useState<string>("unknown");

  useEffect(() => {
    const updateDisplayMode = () => {
      if (document.referrer.startsWith("android-app://")) {
        setDisplayMode("twa");
        return;
      }

      const modes = [
        "browser",
        "standalone",
        "minimal-ui",
        "fullscreen",
        "window-controls-overlay",
      ];

      const currentMode = modes.find(
        (mode) => window.matchMedia(`(display-mode: ${mode})`).matches,
      );

      setDisplayMode(currentMode ?? "unknown");
    };

    updateDisplayMode();

    const mediaQueryLists = [
      "browser",
      "standalone",
      "minimal-ui",
      "fullscreen",
      "window-controls-overlay",
    ].map((mode) => window.matchMedia(`(display-mode: ${mode})`));

    mediaQueryLists.forEach((mql) => {
      mql.addEventListener("change", updateDisplayMode);
    });

    return () => {
      mediaQueryLists.forEach((mql) => {
        mql.removeEventListener("change", updateDisplayMode);
      });
    };
  }, []);

  return displayMode;
}

export function useAppBadge(_opts?: { enabled?: boolean }) {
  const displayMode = useDisplayMode();

  const returnValue = useMemo(() => {
    return {
      total: 0,
    };
  }, []);

  useEffect(() => {
    if (displayMode === "standalone" && "Notification" in window) {
      if (window.Notification.permission !== "denied") {
        window.Notification.requestPermission().then((result) => {
          if (result === "granted") {
            if (returnValue.total > 0 && navigator.setAppBadge) {
              navigator.setAppBadge(returnValue.total);
            } else {
              navigator.clearAppBadge();
            }
          }
        });
      }
    }
  }, [returnValue, displayMode]);

  return returnValue;
}
